import {FC} from 'react'
import {downloadTemplateClient, uploadMasiveClient} from '../../../../services'
import {ShowSnackBar} from '../../../../../../util/functions'
import {FormMasive} from '../../../../../../components/UI/Form/MasiveV2'

const FormMasiveUpload: FC = () => {
  const handleUpload = async (formData: FormData) => {
    try {
      const response = await uploadMasiveClient(formData) // Use the service to upload the file
      return response
    } catch (error) {
      ShowSnackBar('Hubo un error', 'error')
    }
  }
  return (
    <FormMasive
      serviceTemplate={downloadTemplateClient}
      handleSendService={handleUpload}
      title='Cliente'
    />
  )
}

export {FormMasiveUpload}
